import { render } from "./ImportReviewPanel.vue?vue&type=template&id=3ad03589&scoped=true"
import script from "./ImportReviewPanel.vue?vue&type=script&lang=js"
export * from "./ImportReviewPanel.vue?vue&type=script&lang=js"

import "./ImportReviewPanel.vue?vue&type=style&index=0&id=3ad03589&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad03589"]])

export default __exports__